import React, { useState } from 'react';
import { Paper, makeStyles, Grid } from '@material-ui/core';

const numbers = {
  firstRow: [55, 54, 53, 52, 51, '', 61, 62, 63, 64, 65],
  secondRow: [
    18,
    17,
    16,
    15,
    14,
    13,
    12,
    11,
    '',
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
  ],
  thirdRow: [
    48,
    47,
    46,
    45,
    44,
    43,
    42,
    41,
    '',
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
  ],
  fourthRow: [85, 84, 83, 82, 81, '', 71, 72, 73, 74, 75],
  fiveRow: [0],
};

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 100,
    backgroundColor: '#cfcfcf',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  paper: {
    backgroundColor: '#fff',
    padding: '20px',
    margin: '1px 1px 1px 1px',
    width: '30px',
    height: '30px',
    //border: '1px solid #a1a1a1',
    color: '#000',
    transition: 'background-color 0.3s, border-color 0.3s',
    '&:hover': {
      backgroundColor: '#96ceb4',
    },
    selected: {
      backgroundColor: 'red',
    },
  },
  sinPieza: {
    backgroundColor: '#fff',
    padding: '20px',
    width: '100px',
    margin: '1px 1px 1px 1px',
    height: '30px',
    //border: '1px solid #a1a1a1',
    color: '#000',
    transition: 'background-color 0.3s, border-color 0.3s',
    '&:hover': {
      backgroundColor: '#96ceb4',
    },
  },
  selected: {
    backgroundColor: '#96ceb4',
  },
  division: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '2px',
      height: '40px',
      background: '#000',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '50%',
    },
  },
  division2: {
    backgroundColor: '#fff',
    margin: '1px 1px 1px 1px',
    width: '100%',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '50%',
      height: '1px',
      background: '#000',
      bottom: '0',
      left: '25%',
    },
  },
}));

export const Dientes = ({ dienteSeleccionado, disabled }) => {
  const classes = useStyles();
  const [selectedNumber, setSelectedNumber] = useState(null);

  const handleOnClick = (number) => {
    setSelectedNumber(number);
    dienteSeleccionado(number);
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.section}>
            {numbers.firstRow.map((number, index) => (
              <Paper
                disabled={disabled}
                key={index}
                className={`${
                  number !== '' ? classes.paper : classes.division
                } ${selectedNumber === number ? classes.selected : ''} ${
                  number === '' ? classes.division : ''
                }`}
                onClick={() => {
                  if (number !== '') {
                    handleOnClick(number);
                  }
                }}
                elevation={3}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}
                  >
                    {number}
                  </div>
                </div>
              </Paper>
            ))}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.section}>
            {numbers.secondRow.map((number, index) => (
              <Paper
                disabled={disabled}
                key={index}
                className={`${
                  number !== '' ? classes.paper : classes.division
                } ${selectedNumber === number ? classes.selected : ''} ${
                  number === '' ? classes.division : ''
                }`}
                onClick={() => handleOnClick(number)}
                elevation={3}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  {number}
                </div>
              </Paper>
            ))}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.division2}></div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.section}>
            {numbers.thirdRow.map((number, index) => (
              <Paper
                disabled={disabled}
                key={index}
                className={`${
                  number !== '' ? classes.paper : classes.division
                } ${selectedNumber === number ? classes.selected : ''} ${
                  number === '' ? classes.division : ''
                }`}
                onClick={() => handleOnClick(number)}
                elevation={3}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  {number}
                </div>
              </Paper>
            ))}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.section}>
            {numbers.fourthRow.map((number, index) => (
              <Paper
                disabled={disabled}
                key={index}
                className={`${
                  number !== '' ? classes.paper : classes.division
                } ${selectedNumber === number ? classes.selected : ''} ${
                  number === '' ? classes.division : ''
                }`}
                onClick={() => handleOnClick(number)}
                elevation={3}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  {number}
                </div>
              </Paper>
            ))}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.section}>
            {numbers.fiveRow.map((number, index) => (
              <Paper
                disabled={disabled}
                key={index}
                className={`${
                  number !== '' ? classes.sinPieza : classes.division
                } ${selectedNumber === number ? classes.selected : ''} ${
                  number === '' ? classes.division : ''
                }`}
                onClick={() => handleOnClick(number)}
                elevation={3}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  Sin pieza particular
                </div>
              </Paper>
            ))}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
